import Start from './start';
import { setupInterceptors, createI18nInstance } from '@prometheus/utils';
import { store } from './store';
import { setupMonacoWorkers } from './monaco.workers';

// Setup Monaco workers before the app loads
setupMonacoWorkers();

// not sure it's required level - to investigate, let's save it for now
// I assume it could be needed if we would receive modules config from some back end API
function bootstrap() {
  return Promise.resolve({
    root: 'root',
    store,
  });
}

bootstrap().then(async ({ root, store }) => {
  await createI18nInstance();
  setupInterceptors(store);
  Start(root, store);
});
